module.exports = __webpack_public_path__ + "img/ambientacion2-zoom.cfeb5ff7.jpg";